<p>security-policies works!</p>
